import React from "react";
import {
	DataObserveKey,
	FocusableComponent,
	VisualComponent,
	Paragraph,
	SrOnly,
	cn,
} from "@siteimprove/fancylib";
import * as scss from "./pill.scss";

export type PillProps = {
	children: React.ReactChild | React.ReactFragment | undefined;
	variant:
		| ({
				type: "interactive";
				onClick: () => void;
				srOnlyText?: string;
		  } & FocusableComponent)
		| { type: "static" };
	size?: "small" | "medium" | "large";
} & DataObserveKey &
	VisualComponent;

export function Pill(props: PillProps): JSX.Element {
	const { children, variant, size = "medium", className, ...rest } = props;

	const innerNodes = React.Children.map(children, (c) =>
		typeof c === "string" || typeof c === "number" ? (
			<Paragraph lineHeight="single-line" emphasis="medium" size={sizeMap[size]}>
				{c}
			</Paragraph>
		) : (
			c
		)
	);

	const sharedProps = {
		"data-component": "pill",
		className: cn(scss.pill, scss[size], className, "fancy-Pill"),
		...rest,
	};

	if (variant.type === "interactive")
		return (
			<button
				{...sharedProps}
				onClick={variant.onClick}
				className={cn(sharedProps.className, scss.interactive)}
			>
				{innerNodes}
				{variant.srOnlyText && <SrOnly>({variant.srOnlyText})</SrOnly>}
			</button>
		);

	return <div {...sharedProps}>{innerNodes}</div>;
}

const sizeMap = {
	small: "xSmall",
	medium: "small",
	large: "medium",
} as const;
